const selectors = {
  container: "div.media-container",
};

export default selectors;
